// extracted by mini-css-extract-plugin
export default {"section":"loader_section__-Aq0O","loader":"loader_loader__ldthz","animate":"loader_animate__R9+Ho","animateBg":"loader_animateBg__072DJ"};